import { Data2, newId, dateToString } from '../../../features/data-types'
import { useSystemStateHooks } from '../../system'
import { Check, CheckStatus, CheckType } from '../state/types'

export const useCheckBuilders = () => {
    const { companyId } = useSystemStateHooks()

    const buildCheck = (data: Data2) => {
        const { id = newId(), type, name, amount, issueDate, entryDate, taxId, endorsable, status, archived } = data
        const paymentDate = dateToString(data.paymentDate)!
        const defaultStatus = paymentDate > dateToString(new Date())! ? CheckStatus.DEFERRED : CheckStatus.EMITTED
        const check: Check = {
            companyId: companyId!,
            id: id! as string,
            type: type! as CheckType,
            name: name! as string,
            amount: amount! as number,
            issueDate: dateToString(issueDate)!,
            paymentDate,
            entryDate: dateToString(entryDate || new Date())!,
            taxId: taxId! as number,
            endorsable: !!endorsable as boolean,
            status: (status || defaultStatus) as CheckStatus,
            archived: !!archived
        }

        return check
    }

    return {
        buildCheck
    }
}
